import { Heading } from '@core/ui';

import { AuthSideHeaderProps } from './types';

export const AuthSideHeader = ({ children }: AuthSideHeaderProps) => (
    <Heading variant="h2" classNames="mt-2 mb-6">
        {children}
    </Heading>
);
